module.exports = __webpack_public_path__ + "img/Feature.2dd3a8e9.png";